var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoVkidBlack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 16,
    viewBox: "0 0 33 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13h1.648V3.5H20V13ZM23.78 13h3.694c2.939 0 5.026-1.967 5.026-4.757 0-2.776-2.087-4.743-5.026-4.743H23.78V13Zm1.648-1.482V4.982h2.046c1.964 0 3.31 1.334 3.31 3.261 0 1.94-1.346 3.275-3.31 3.275h-2.046Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.68c0-3.62 0-5.43 1.125-6.555C2.249 0 4.06 0 7.68 0h.64c3.62 0 5.43 0 6.555 1.125C16 2.249 16 4.06 16 7.68v.64c0 3.62 0 5.43-1.125 6.555C13.751 16 11.94 16 8.32 16h-.64c-3.62 0-5.43 0-6.555-1.125C0 13.751 0 11.94 0 8.32v-.64Z",
    fill: "#07F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.563 11.66c-3.646 0-5.726-2.5-5.813-6.66h1.827c.06 3.053 1.406 4.343 2.473 4.61V5h1.72v2.63c1.053-.113 2.16-1.31 2.533-2.63h1.72c-.286 1.627-1.486 2.827-2.34 3.32.854.4 2.22 1.447 2.74 3.34H11.53c-.407-1.267-1.42-2.247-2.76-2.38v2.38h-.207Z",
    fill: "#fff"
  })));
};
export default SvgLogoVkidBlack;